import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { UploadOrderDocumentsPopover } from "pages/order-managment/upload-order-documents/upload-order-documents";
import { UploadOrderDocumentsPageModule } from "pages/order-managment/upload-order-documents/upload-order-documents.module";
import { CreateCommentModalPage } from "../../../pages/inter-disciplinary-group/create-comment-modal/create-comment-modal";
import { CreateCommentModalPageModule } from "../../../pages/inter-disciplinary-group/create-comment-modal/create-comment-modal.module";
import { EditViewPopoverPage } from "./edit-view-popover";

@NgModule({
  declarations: [EditViewPopoverPage],
  imports: [
    IonicPageModule.forChild(EditViewPopoverPage),
    TranslateModule,
    UploadOrderDocumentsPageModule,
    CreateCommentModalPageModule,
  ],
  entryComponents: [UploadOrderDocumentsPopover, CreateCommentModalPage],
})
export class EditViewPopoverPageModule {}



// WEBPACK FOOTER //
// ./src/navigation/components/edit-view-popover/edit-view-popover.module.ts